import React from 'react';
import WorkflowTemplate from '../../components/WorkflowTemplate';
import { LEAD_STAGES } from 'models/Lead';

const WorkflowAcceptPage: React.FC = () => (
  <WorkflowTemplate page={LEAD_STAGES.ACCEPT} />
);

export default WorkflowAcceptPage;
